// On CHP Physician detail page, show service location data for the selected service location

function registerServiceLocationSelectFunctionality() {
  const serviceLocationSelect = document.querySelector('#physicianServiceLocationSelect')
  const serviceLocationInfos = document.querySelector('.physician-service-location-infos')
  const serviceLocationMaps = document.querySelector('.physician-service-location-maps')

  if (serviceLocationSelect && serviceLocationInfos && serviceLocationMaps) {
    serviceLocationSelect.addEventListener('change', event => {
      let value = serviceLocationSelect.value
      displayServiceLocationInfo(value, serviceLocationInfos, serviceLocationMaps)
    })

    let value = serviceLocationSelect.value
    displayServiceLocationInfo(value, serviceLocationInfos, serviceLocationMaps)
  }
}

function displayServiceLocationInfo(index, serviceLocationInfos, serviceLocationMaps) {
  console.log(index)
  const infos = Array.from(serviceLocationInfos.children)
  const maps = Array.from(serviceLocationMaps.children)

  infos.forEach(i => i.classList.remove('active'))
  maps.forEach(m => m.classList.remove('active'))

  if (infos[index]) {
    infos[index].classList.add('active')
  }

  if (maps[index]) {
    maps[index].classList.add('active')
  }
}

document.addEventListener('DOMContentLoaded', (event) => {
  registerServiceLocationSelectFunctionality()
})